import { combineReducers } from "redux";
import session from "./session/reducers";
import catalog from "./catalog/reducers";
import checkout from "./checkout/reducers";
import ui from "./ui/reducers";

export { default as sessionActions } from "./session/actions";
export { default as sessionOperations } from "./session/operations";
export { default as sessionSelectors } from "./session/selectors";
export { default as catalogActions } from "./catalog/actions";
export { default as catalogOperations } from "./catalog/operations";
export { default as catalogSelectors } from "./catalog/selectors";
export { default as checkoutActions } from "./checkout/actions";
export { default as checkoutOperations } from "./checkout/operations";
export { default as checkoutSelectors } from "./checkout/selectors";
export { default as uiActions } from "./ui/actions";
export { default as uiSelectors } from "./ui/selectors";

export default combineReducers({ session, catalog, checkout, ui });
